import React, { useState, useEffect } from "react";
import { Modal, Table, Card, Typography, Space } from "antd";
import { getDirectusClient } from "../../../lib/directus";
import { readItems } from "@directus/sdk";
import moment from "moment";
import { useSelector } from "react-redux";
import { formatPrice } from "../../../lib/utils";

const { Text } = Typography;

const VendorDetails = ({ visible, vendor, onClose, cajasIds }) => {
  const signoMoneda = useSelector((state) => state.signoMoneda.signo_moneda);
  const [loading, setLoading] = useState(false);
  const [facturas, setFacturas] = useState([]);
  const [tableData, setTableData] = useState([]);


  const fetchFacturas = async () => {
    if (!vendor?.id) return;

    setLoading(true);
    try {
      const directus = await getDirectusClient();
      const response = await directus.request(
        readItems("facturas", {
          fields: [
            "id",
            "caja.id",
            "caja.vendedor.id",
            "caja.vendedor.first_name",
            "productos.cantidad",
            "productos.precio_unitario",
            "productos.producto.grupo.impuesto",
            "estado",
            "tipo",
            "consecutivo",
            "date_created",
            "productos.cantidad",
            "productos.producto.nombre",
            "cliente.first_name",
            "cliente.last_name",
          ],
          filter: {
            caja: { _in: cajasIds },
          },
        })
      );

      setFacturas(response);
    } catch (error) {
      console.error("Error fetching facturas:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (visible && vendor) {
      fetchFacturas();
    }
  }, [visible, vendor]);

  useEffect(() => {
    // Generar filas por producto
    const rows = [];
    facturas.forEach((factura) => {
      (factura.productos || []).forEach((prod, idx) => {
        const cantidad = parseFloat(prod.cantidad) || 0;
        const precio_unitario = parseFloat(prod.precio_unitario) || 0;
        const impuestoRaw = prod.producto?.grupo?.impuesto;
        const impuesto = parseFloat(impuestoRaw?.toString().replace(',', '.') || '0') || 0;
        const total = cantidad * precio_unitario;
        const totalConImpuesto = total + (total * impuesto / 100);
        rows.push({
          key: `${factura.id}-${idx}`,
          facturaId: factura.id,
          consecutivo: factura.consecutivo,
          cliente: factura.cliente,
          date_created: factura.date_created,
          producto_nombre: prod.producto?.nombre,
          cantidad,
          precio_unitario,
          impuesto,
          total,
          totalConImpuesto,
        });
      });
    });
    setTableData(rows);
  }, [facturas]);

  const columns = [
    {
      title: "Consecutivo",
      dataIndex: "consecutivo",
      key: "consecutivo",
    },
    {
      title: "Cliente",
      key: "cliente",
      render: (_, record) =>
        `${record.cliente?.first_name || ""} ${
          record.cliente?.last_name || ""
        }`,
    },
    {
      title: "Fecha",
      dataIndex: "date_created",
      key: "date_created",
      render: (date) => moment(date).format("DD/MM/YYYY"),
    },
    {
      title: "Producto",
      dataIndex: "producto_nombre",
      key: "producto_nombre",
    },
    {
      title: "Cantidad",
      dataIndex: "cantidad",
      key: "cantidad",
    },
    {
      title: "Precio Unitario",
      dataIndex: "precio_unitario",
      key: "precio_unitario",
      render: (value) => formatPrice(value, signoMoneda),
    },
    {
      title: "Impuesto",
      dataIndex: "impuesto",
      key: "impuesto",
    },
    {
      title: "Total",
      dataIndex: "total",
      key: "total",
      render: (value) => formatPrice(value, signoMoneda),
    },
    {
      title: "Total + Impuesto",
      dataIndex: "totalConImpuesto",
      key: "totalConImpuesto",
      render: (value) => formatPrice(value, signoMoneda),
    },
  ];

  return (
    <Modal
      title={`Facturas de ${vendor?.first_name || ""}`}
      open={visible}
      onCancel={onClose}
      width={1200}
      footer={null}
    >
      <Table
        columns={columns}
        dataSource={tableData}
        loading={loading}
        rowKey="key"
        pagination={{ pageSize: 10 }}
        summary={(pageData) => (
          <Table.Summary.Row>
            <Table.Summary.Cell index={0} colSpan={4}>
              <Text strong>Totales:</Text>
            </Table.Summary.Cell>
            <Table.Summary.Cell index={4}>
              <Text strong>
                {pageData.reduce((sum, record) => sum + (record.cantidad || 0), 0)}
              </Text>
            </Table.Summary.Cell>
            <Table.Summary.Cell index={5} />
            <Table.Summary.Cell index={6} />
            <Table.Summary.Cell index={7}>
              <Text strong>
                {formatPrice(pageData.reduce((sum, record) => sum + (record.total || 0), 0), signoMoneda)}
              </Text>
            </Table.Summary.Cell>
            <Table.Summary.Cell index={8}>
              <Text strong>
                {formatPrice(pageData.reduce((sum, record) => sum + (record.totalConImpuesto || 0), 0), signoMoneda)}
              </Text>
            </Table.Summary.Cell>
          </Table.Summary.Row>
        )}
      />
    </Modal>
  );
};

export default VendorDetails;
